const { Parser } = require('json2csv');

export const JsonToCsv = (data: any, fields: any) => {
    const json2csvParser = new Parser({ fields, withBOM: true });
    return json2csvParser.parse(data);
}